import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAllRoles, mangeUserRole } from 'api/MakhsanApi';
import { RootState, TThunkApi } from 'store/store';
import { updateUserRoles } from 'store/makhsanUserInfo/makhsanUserInfoSlice';

export interface IRole {
  id: number;
  roleName: string;
}

export interface IRoles {
  [key: number]: IRole;
}

const initialState: IRoles = {};

const addOrUpdateRolesHandler = (
  state: IRoles,
  action: PayloadAction<{ roles: Array<IRole> }>
) => {
  action.payload.roles.forEach((role) => {
    state[role.id] = role;
  });
};

export const makhsanGetAllRolesFn = async (_: any, ThunkApi: TThunkApi) => {
  const store = ThunkApi.getState() as RootState;

  return getAllRoles(store).then(({ data: roles }) => {
    ThunkApi.dispatch(addOrUpdateRoles({ roles }));
    return Promise.resolve({ roles });
  });
};
const makhsanGetAllRoles = createAsyncThunk(
  'makhsanRoles/makhsanGetAllRoles',
  makhsanGetAllRolesFn
);

export const onManageRoleFn = async (
  { userId, role, action }: { userId: number; role: string; action: string },
  ThunkApi: TThunkApi
) => {
  const store = ThunkApi.getState() as RootState;
  return mangeUserRole(store, userId, role, action).then(() => {
    ThunkApi.dispatch(updateUserRoles({ userId, role, action }));
    return Promise.resolve();
  });
};
const onManageRole = createAsyncThunk(
  'makhsanRoles/onManageRole',
  onManageRoleFn
);

const makhsanRolesSlice = createSlice({
  name: 'makhsanRoles',
  initialState: initialState,
  reducers: {
    addOrUpdateRoles: addOrUpdateRolesHandler,
  },
});

export const { addOrUpdateRoles } = makhsanRolesSlice.actions;

export { makhsanGetAllRoles, onManageRole };

export default makhsanRolesSlice.reducer;
